import { Link } from "react-router-dom";
import { ArrowRight, CheckCircle2, Shield } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function HomeInsurancePage() {
  const features = [
    {
      title: "Building Insurance",
      desc: "Covering the structure of your home against damage caused by unforeseen events such as fire, floods, storms, or accidents, so you can rebuild and repair without financial stress.",
    },
    {
      title: "Contents Insurance",
      desc: "Protecting your possessions — from furniture to electronics — against theft, loss, or damage, ensuring the things that make your house a home are safeguarded.",
    },
    {
      title: "Landlord Insurance",
      desc: "Specialised coverage for property owners renting out their homes, protecting against risks like damage to the building, loss of rental income, and liability claims from tenants.",
    },
  ];

  return (
    <div data-testid="home-insurance-page">
      <section className="relative bg-[#111111] py-32 lg:py-40">
        <div className="absolute inset-0 bg-[url('https://images.unsplash.com/photo-1600585154340-be6161a56a0c?w=1920&q=80')] bg-cover bg-center opacity-15" />
        <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <p className="text-[#d64241] font-semibold text-sm tracking-widest uppercase mb-3 font-body">Home Insurance Service</p>
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-white tracking-tight">
            Home<br />
            <span className="text-[#d64241]">Insurance</span>
          </h1>
        </div>
      </section>

      <section data-testid="home-insurance-content" className="py-20 lg:py-28 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid lg:grid-cols-2 gap-16 items-start">
            <div>
              <div className="w-14 h-14 rounded-xl bg-[#fef2f2] flex items-center justify-center mb-6">
                <Shield className="w-7 h-7 text-[#d64241]" />
              </div>
              <h2 className="text-3xl md:text-4xl font-semibold text-black tracking-tight mb-6">
                Comprehensive Home Insurance
              </h2>
              <p className="text-base md:text-lg text-gray-600 leading-relaxed mb-8 font-body">
                At KK Mortgage Solutions, we believe protecting your property and belongings is essential for peace of mind. Our tailored home insurance services provide comprehensive coverage, ensuring you're prepared for the unexpected. Whether you're a homeowner, tenant, or landlord, we've got the right protection for your needs.
              </p>
              <div className="space-y-6 mb-10">
                {features.map((f, i) => (
                  <div key={i} className="flex gap-4">
                    <CheckCircle2 className="w-5 h-5 text-[#d64241] flex-shrink-0 mt-1" />
                    <div>
                      <h3 className="font-semibold text-black mb-1">{f.title}</h3>
                      <p className="text-sm text-gray-600 font-body leading-relaxed">{f.desc}</p>
                    </div>
                  </div>
                ))}
              </div>
              <p className="text-base md:text-lg text-gray-600 leading-relaxed mb-8 font-body">
                We make finding the right home insurance simple, affordable, and personalised. With our expert advice and trusted providers, you can secure the protection you need to enjoy your home or investment with confidence.
              </p>
              <Link to="/contact">
                <Button data-testid="home-insurance-cta-btn" className="bg-[#d64241] hover:bg-[#b53736] text-white rounded-full px-8 py-6 text-base font-semibold shadow-lg shadow-[#d64241]/25 hover:-translate-y-0.5 transition-all duration-200">
                  Get a Quote <ArrowRight className="w-4 h-4 ml-1" />
                </Button>
              </Link>
            </div>
            <div>
              <div className="rounded-2xl overflow-hidden shadow-[0_20px_60px_rgba(0,0,0,0.1)]">
                <img src="https://images.unsplash.com/photo-1600585154340-be6161a56a0c?w=800&q=80" alt="Home insurance" className="w-full h-[400px] lg:h-[550px] object-cover" />
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
